import { defineComponent as _defineComponent } from 'vue'
import { CdnImg } from '@webplatform/cdn-image';
import { useBreakpoint, useMediaAsset } from '~/composables';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SoftwareCategoryChoosePlan',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {



const gradients = [
  'from-[#432A9E] to-[#2050A7]',
  'from-[#635E78] to-[#485876]',
];

const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const getPlanHeaderBg = (index: number) => gradients[index];

return { __sfc: true,gradients, getAssetUrl, isDesktop, getPlanHeaderBg, CdnImg, handleImageSrc, handleImageAlt }
}

})